var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9128 1.08719C24.7777 0.951599 24.6043 0.86072 24.4159 0.826821C24.2276 0.792922 24.0334 0.817636 23.8595 0.897625L1.35949 11.2101C1.17101 11.2964 1.01646 11.4427 0.919981 11.6262C0.823507 11.8097 0.790559 12.0199 0.82629 12.2241C0.862021 12.4283 0.964415 12.6149 1.11746 12.7547C1.2705 12.8945 1.46557 12.9797 1.67214 12.9968L12.1316 13.8687L13.0034 24.3281C13.0206 24.5347 13.1057 24.7297 13.2455 24.8828C13.3853 25.0358 13.5719 25.1382 13.7761 25.1739C13.9803 25.2097 14.1906 25.1767 14.374 25.0803C14.5575 24.9838 14.7038 24.8292 14.7901 24.6407L25.1026 2.14075C25.1822 1.96674 25.2067 1.77255 25.1728 1.58423C25.1388 1.3959 25.0481 1.22247 24.9128 1.08719ZM14.575 20.6094L13.9346 12.9219C13.9162 12.7009 13.82 12.4936 13.6632 12.3368C13.5064 12.1799 13.2991 12.0838 13.0781 12.0654L5.39055 11.425L22.3461 3.65387L14.575 20.6094Z",
    fill: "#7F7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.84e824712b58a5f3607591d6a8ae95c1.svg";
export { ForwardRef as ReactComponent };